import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { isObject } from "../../../Libs/CustomMethods/customMethods";
import { resetClientInfo } from "../../../store/clientInformation/actions";

const useMessageConversation = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return {
    handleNewMessageQueue: (data, buffer, setBuffer, spyConversationId) => {
      dispatch(resetClientInfo(data?.conversationId));

      if (history.location.pathname === "/chats") {
        if (!spyConversationId) {
          let e = { ...data, type: "new", by: "consumer" };
          let queue = buffer?.queue;

          // Prevent duplicate entries in the queue
          if (!queue?.some((c) => c.conversationId === e?.conversationId)) {
            let aux = buffer.queue;

            aux.push(e);
            setBuffer(() => ({
              queue: aux,
            }));
          }
        }
      }
    },
    handleNewMessageTelegram: (data, buffer, setBuffer, spyConversationId) => {
      if (history.location.pathname === "/chats") {
        if (
          !spyConversationId ||
          (spyConversationId && data?.conversationId === spyConversationId)
        ) {
          let e = { ...data, by: "consumer" };
          let aux = buffer.queue;
          aux.push(e);
          setBuffer(() => ({
            queue: aux,
          }));
        }
      }
    },
    handleNewMessageFromAgent: (data, buffer, setBuffer, spyConversationId) => {
      if (history.location.pathname === "/chats") {
        if (
          !spyConversationId ||
          (spyConversationId && data?.conversationId === spyConversationId)
        ) {
          let e = { ...data, type: "msgFromAgent", by: "agent" };
          let aux = buffer.queue;
          aux.push(e);
          setBuffer(() => ({
            queue: aux,
          }));
        }
      }
    },
    handleNewMessageFromManager: (data, buffer, setBuffer) => {
      if (history.location.pathname === "/chats") {
        let e = { ...data, type: "msgFromManager", by: "manager" };
        let aux = buffer.queue;
        aux.push(e);
        setBuffer(() => ({
          queue: aux,
        }));
      }
    },
    handleNewMessagePrivate: (data, buffer, setBuffer, spyConversationId) => {
      if (history.location.pathname === "/chats") {
        if (
          !spyConversationId ||
          (spyConversationId && data?.conversationId === spyConversationId)
        ) {
          if (isObject(data)) {
            let e = { ...data, type: "private" };
            let aux = buffer.queue;
            aux.push(e);
            setBuffer(() => ({
              queue: aux,
            }));
          }
        }
      }
    },
  };
};

export default useMessageConversation;
